import { publicApi } from "utils/util";

interface GetClassCurationsDetailApiRequest {
  curationId?: string;
}

interface RegistrationStatusLabel {
  before: string;
  inProgress: string;
  completed: string;
}

interface GetClassCurationsDetailApiStudent {
  registrationStatusLabel: RegistrationStatusLabel;
  numVoucher: number;
  studentCourses: any[];
  likes: any[];
}

interface ThumbnailImage {
  name: string;
  link: string;
  isPublic: boolean;
}

interface Product {
  variantId: string;
  productId: string;
  salePrice: number;
  productName: string;
  regularPrice: number;
  tags: string[];
}

interface GroupedBadges {
  topics?: string[];
  level?: string[];
  toothNumbers?: string[];
  topicCategory?: string[];
  topicSubCategory?: string[];
}

interface Course {
  groupedBadges: GroupedBadges;
  avgReviewScore: number;
  description: string;
  title: string;
  lecturerNames: string[];
  products: Product[];
  badges: string[];
  numReview: number;
  isFree: boolean;
  isClosed: boolean;
  subcategoryId: string;
  thumbnailImage: ThumbnailImage;
  courseId: string;
  categoryId: string;
}

interface Curation {
  courses: Course[];
  title: string;
  curationId: string;
  subtitle: string;
}

interface GetClassCurationsDetailApiResponse {
  student: GetClassCurationsDetailApiStudent;
  curation: Curation;
}

/**
 * MARK: curationId에 해당하는 큐레이션의 클래스 목록을 가져옵니다.
 */
export const getClassCurationsDetailApi = async ({
  curationId,
}: GetClassCurationsDetailApiRequest): Promise<GetClassCurationsDetailApiResponse> => {
  if (!publicApi) throw new Error("[getClassCurationsDetailApi] publicApi 주입에 실패했습니다.");

  if (!curationId) throw new Error("[getClassCurationsDetailApi] curationId가 없습니다.");

  const publicApiResponse = await publicApi.get<GetClassCurationsDetailApiResponse>(
    `/class/curations/${curationId}`,
  );

  if (
    publicApiResponse.status >= 200 &&
    publicApiResponse.status < 300 &&
    !!publicApiResponse.data
  ) {
    return publicApiResponse.data;
  }

  throw new Error("[getClassCurationsDetailApi] 서버 요청에 실패했습니다.");
};

interface GetClassPublicCurationsDetailApiRequest {
  curationId?: string;
}

interface GetClassPublicCurationsDetailApiResponse {
  curation: Curation;
}

export const getClassPublicCurationDetailApi = async ({
  curationId,
}: GetClassPublicCurationsDetailApiRequest) => {
  if (!publicApi)
    throw new Error("[getClassPublicCurationsDetailApi] publicApi 주입에 실패했습니다.");

  if (!curationId) throw new Error("[getClassPublicCurationsDetailApi] curationId가 없습니다.");

  const publicApiResponse = await publicApi.get<GetClassPublicCurationsDetailApiResponse>(
    `/class/public/curations/${curationId}`,
  );

  if (
    publicApiResponse.status >= 200 &&
    publicApiResponse.status < 300 &&
    !!publicApiResponse.data
  ) {
    return publicApiResponse.data;
  }

  throw new Error("[getClassPublicCurationsDetailApi] 서버 요청에 실패했습니다.");
};
